<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="U8intmentRefs" :options="item.options" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<U8interfacemangementtable :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</U8interfacemangementtable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Dialog from '../../../../components/dialog.vue'
	import U8interfacemangementtable from './components/U8interfacemangementtable.vue'
	import {
		U8SynchronousList,
		HelperU8MethodName,
		HelperU8InterfaceStatus,
		HelperU8AccId
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			U8interfacemangementtable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '接口类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px'
					},

					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: '账套号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px'
					},
					{
						inputdata: '',
						title: '序号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
					},
					{
						inputdata: '',
						title: 'U8单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
					}
				],
				from: {
					methodName: "",
					status: null,
					createTime1: "",
					createTime2: "",
					cusName: "",
					accId: "",
					id: null,
					U8RdCode: ''
				}
			}
		},
		mounted() {
			this.helperU8MethodName()
			this.helperU8InterfaceStatus()
			this.u8SynchronousList()
			this.helperU8AccId()
		},
		methods: {
			// 列表
			async u8SynchronousList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await U8SynchronousList({
					methodName: this.from.methodName,
					status: this.from.status,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					cusName: this.from.cusName,
					accId: this.from.accId,
					id: this.from.id,
					U8RdCode: this.from.U8RdCode,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				}
				loading.close();
			},
			// 接口类型下拉
			async helperU8MethodName() {
				let {
					code,
					data
				} = await HelperU8MethodName({})
				this.formdata[0].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[0].options.push(obj)
				})
			},
			// 接口状态下拉
			async helperU8InterfaceStatus() {
				let {
					code,
					data
				} = await HelperU8InterfaceStatus({})
				this.formdata[1].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[1].options.push(obj)
				})
			},
			// U8套账号
			async helperU8AccId() {
				let {
					code,
					data
				} = await HelperU8AccId({})
				this.formdata[4].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[4].options.push(obj)
				})
			},
			reset() {
				this.$refs.U8intmentRefs.forEach((item, index) => {
					if (index == 2) {
						item.startTime = ''
						item.endTime = ''
					}
					item.modelvalue = ''
				})

			},
			select() {
				this.pageindex = 1
				try {
					this.from.methodName = this.$refs.U8intmentRefs[0].modelvalue
					this.from.status = this.$refs.U8intmentRefs[1].modelvalue
					this.from.createTime1 = this.$refs.U8intmentRefs[2].startTime
					this.from.createTime2 = this.$refs.U8intmentRefs[2].endTime
					this.from.cusName = this.$refs.U8intmentRefs[3].modelvalue
					this.from.accId = this.$refs.U8intmentRefs[4].modelvalue
					this.from.id = Number(this.$refs.U8intmentRefs[5].modelvalue)
					this.from.U8RdCode = this.$refs.U8intmentRefs[6].modelvalue
					this.u8SynchronousList()
				} catch (error) {
					this.u8SynchronousList()
				}

			},
			hide() {
				this.showorhide = false
				// //console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.u8SynchronousList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.u8SynchronousList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 60px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 320px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 50px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 10px;
	}
</style>
